import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';
import { NewHomesFeedFragment } from '../types/graphqlTypes';
import { PROPERTY_URLS } from '../urls';
import { startWithSlash } from '../utils/startWithSlash';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { PropertyCard } from './properties/PropertyCard';
import { Section } from './Section';

interface NewHomesFeedProps extends NewHomesFeedFragment {
  width: 'narrow' | 'wide';
}

export const NewHomesFeed: FC<Omit<NewHomesFeedProps, '__typename'>> = ({
  title,
  backgroundColour,
  newHomes,
  width,
}) => {
  const { newHomePropertyData } = useStaticQuery(graphql`
    query newHomePropertyQuery {
      newHomePropertyData: allKfhPropertyTypeInterface(
        filter: { propertyAge: { eq: "New home" }, available: { eq: true } }
      ) {
        edges {
          node {
            id
          }
        }
      }
    }
  `);

  if (newHomes.length < 1) {
    return null;
  }
  const totalCount = newHomePropertyData.edges.length;
  const heading = title || `We have ${totalCount} new homes across London.`;

  return (
    <Section
      background={backgroundColour || 'grey'}
      contained
      narrow={width === 'narrow'}
      customButton={{
        label: 'View all new homes',
        url: startWithSlash(PROPERTY_URLS.newHomeProperties),
        arrowRight: true,
      }}
      overflowHidden
    >
      <CardCarouselWrapper heading={heading} width={width}>
        {newHomes.map((property, index) => (
          <>
            {property && (
              <PropertyCard
                property={property}
                key={index}
                vertical
                hideActions
                singleImage
                disableGallerySwipeOnMobile
                onWhiteBg={backgroundColour === 'white'}
              />
            )}
          </>
        ))}
      </CardCarouselWrapper>
    </Section>
  );
};
